<template>
  <section class="ai-scene-cards">
    <h3>{{ card.title }}</h3>
    <ai-list-surface :scrolled="hasDeviceScrolled">
      <div ref="deviceScroll" class="ai-list-scroll scene-scroll" :class="{ 'is-scrollable': hasDeviceOverflow }" @scroll.passive="measureDeviceOverflow(); loadDevicesOnScroll()" tabindex="0" role="region" aria-label="场景列表"><div ref="deviceGrid" class="scene-grid" :style="{ '--device-columns': deviceColumns }">
      <div v-for="item in card.items" :key="item.ref.sceneId" class="scene-preview" @contextmenu.capture.stop.prevent>
        <div inert aria-hidden="true"><original-scene-card :one-scene="item.preview" :disabled="true" /></div>
        <button class="scene-hit" :disabled="disabled || loading || !valid || !card.source" :aria-busy="loading" :aria-label="'手动操作 ' + item.title" @click="open(item)"></button>
      </div>
      </div></div>
    </ai-list-surface>
    <footer class="ai-list-footer">
      <span>{{ card.footerText }}</span>
      <span v-if="pagination.loading" role="status">加载中…</span>
      <button v-else-if="pagination.error" class="scene-more" :disabled="busy" @click="requestDevicePage(true)">加载失败，点击重试</button>
      <span v-else-if="card.hasMore && hasDeviceOverflow">向下滚动加载更多</span>
      <button v-else-if="card.hasMore" class="scene-more" :disabled="busy" @click="requestDevicePage(true)">加载更多</button>
    </footer>
    <p v-if="error" role="status">{{ error }}</p>
    <p v-else-if="loading">正在读取…</p>
  </section>
</template>
<script>
import behavior from './mixins/card-behavior'
import grid from './mixins/card-grid-behavior'
import scrollbarBehavior from './mixins/scrollbar-behavior'
import AiListSurface from './AiListSurface.vue'
import OriginalSceneCard from '@/components/content/contro-view/scene-view/scene-item-view.vue'
import { createAiClient, identity, errorMessage } from '@/ai/services/api'
import { readDetail } from '@/ai/services/detail-sources'
import { validateDetailContent } from '@/ai/protocol/detail-views'
import { claimManualSurface, releaseManualSurface } from '@/ai/services/manual-device-bridge'
import { jieMianStateJudge } from '@/common/tool.js'
export default {
  mixins: [behavior, grid, scrollbarBehavior],
  components: { AiListSurface, OriginalSceneCard },
  inject: { aiPageState: { default: null } },
  data: () => ({ loading: false, error: '', valid: true, ownsPopup: false, sceneId: null }),
  watch: { 'aiPageState.valid'(value) { if (value === false) this.invalidate() } },
  mounted() {
    this._alive = true; this._scope = identity(); this._client = createAiClient()
    this._unwatch = this.$store.watch(s => s.publicinfo.objData, value => {
      if (this.ownsPopup && (!value || value.sceneId !== this.sceneId)) { this.ownsPopup = false; releaseManualSurface(this) }
    })
  },
  beforeDestroy() { this._alive = false; this.invalidate(); if (this._unwatch) this._unwatch() },
  methods: {
    current() { return this._alive && this.valid && this._scope === identity() },
    invalidate() {
      this.valid = false
      if (this._client) this._client.close()
      if (this.ownsPopup && (this.$store.state.publicinfo.objData || {}).sceneId === this.sceneId) this.$closeControlToast()
      this.ownsPopup = false; releaseManualSurface(this)
    },
    async open(item) {
      if (!this.card.source || this.disabled || this.loading || !this.current() || !jieMianStateJudge()) return
      const occupied = () => { const value = this.$store.state.publicinfo.objData; return value && (value.productId || value.sceneId) }
      if (occupied() || !claimManualSurface(this)) { this.error = '请先关闭当前控制面板'; return }
      this.loading = true; this.error = ''
      try {
        // Refresh the action-bound scene under current permissions; this endpoint never executes it.
        const result = validateDetailContent(await (this.card.source.kind === 'scene_read'
          ? this._client.post('scene/get', { sceneId: item.ref.sceneId })
          : readDetail(this._client, this.card.source)))
        if (!this.current() || this.disabled) return
        const target = result.items.find(value => value.ref.sceneId === item.ref.sceneId)
        if (!target || occupied()) { this.error = '场景不可用或已有控制面板打开，请重新查看'; return }
        const scene = JSON.parse(JSON.stringify(target.preview))
        this.sceneId = scene.sceneId; this.ownsPopup = true
        await this.$store.dispatch('asyUpdataobjData', scene)
        if (!this.current() || this.disabled) { this.invalidate(); return }
        this.$showControlToast('scene', scene)
      } catch (error) { if (this.current()) this.error = errorMessage(error) }
      finally { this.loading = false; if (!this.ownsPopup) releaseManualSurface(this) }
    }
  }
}
</script>
<style scoped src="./surfaces.css"></style>
<style scoped>
.scene-scroll{max-height:248px}.scene-grid{display:grid;grid-template-columns:repeat(var(--device-columns,1),minmax(0,180px));gap:10px}.scene-more{border:0;background:none;color:#2563c7;padding:8px;cursor:pointer}

h3{font-size:15px;font-weight:500;margin:0 0 12px}.scene-preview{position:relative;min-width:0;box-sizing:border-box}.scene-hit{position:absolute;inset:0;border:0;border-radius:14px;background:transparent;cursor:pointer}.scene-hit:disabled{cursor:default}.scene-hit:focus-visible{outline:2px solid #3975df;outline-offset:2px}p{font-size:12px;color:#637185;margin:12px 0 0}
</style>
